const schools = [
  {
    label: "University of Akron School of Law",
    value: "university-of-akron-school-of-law",
  },
  {
    label: "University of Alabama School of Law",
    value: "university-of-alabama-school-of-law",
  },
  { label: "Albany Law School", value: "albany-law-school" },
  {
    label: "American University Washington College of Law",
    value: "american-university-washington-college-of-law",
  },
  { label: "Appalachian School of Law", value: "appalachian-school-of-law" },
  {
    label: "University of Arizona James E. Rogers College of Law",
    value: "university-of-arizona-college-of-law",
  },
  {
    label: "Arizona State University Sandra Day O’Connor College of Law",
    value: "arizona-state-university-college-of-law",
  },
  {
    label: "University of Arkansas School of Law - Fayetteville",
    value: "university-of-arkansas-school-of-law-fayetteville",
  },
  {
    label:
      "University of Arkansas at Little Rock, William H. Bowen School of Law",
    value: "university-of-arkansas-little-rock-law-school",
  },
  {
    label: "Atlanta's John Marshall Law School",
    value: "atlantas-john-marshall-law-school",
  },
  { label: "Ave Maria School of Law", value: "ave-maria-school-of-law" },
  {
    label: "University of Baltimore School of Law",
    value: "university-of-baltimore-school-of-law",
  },
  {
    label: "Barry University School of Law",
    value: "barry-university-school-of-law",
  },
  { label: "Baylor Law School", value: "baylor-law-school" },
  {
    label: "Belmont University College of Law",
    value: "belmont-university-college-of-law",
  },
  { label: "Boston College Law School", value: "boston-college-law-school" },
  {
    label: "Boston University School of Law",
    value: "boston-university-school-of-law",
  },
  {
    label: "Brigham Young University J. Reuben Clark Law School",
    value: "brigham-young-university-law-school",
  },
  { label: "Brooklyn Law School", value: "brooklyn-law-school" },
  {
    label: "University at Buffalo School of Law",
    value: "university-at-buffalo-school-of-law",
  },
  {
    label: "University of California, Berkeley School of Law",
    value: "university-of-california-berkeley-school-of-law",
  },
  {
    label: "University of California, Davis School of Law",
    value: "university-of-california-davis-school-of-law",
  },
  {
    label: "University of California, San Francisco College of the Law",
    value: "university-of-california-san-francisco-law-school",
  },
  {
    label: "University of California, Irvine School of Law",
    value: "university-of-california-irvine-school-of-law",
  },
  {
    label: "University of California, Los Angeles School of Law",
    value: "university-of-california-los-angeles-school-of-law",
  },
  {
    label: "California Western School of Law",
    value: "california-western-school-of-law",
  },
  {
    label: "Campbell University Norman Adrian Wiggins School of Law",
    value: "campbell-university-school-of-law",
  },
  {
    label: "Capital University Law School",
    value: "capital-university-law-school",
  },
  {
    label: "Case Western Reserve University School of Law",
    value: "case-western-reserve-university-school-of-law",
  },
  {
    label: "The Catholic University of America Columbus School of Law",
    value: "catholic-university-of-america-law-school",
  },
  {
    label: "Chapman University Dale E. Fowler School of Law",
    value: "chapman-university-school-of-law",
  },
  { label: "Charleston School of Law", value: "charleston-school-of-law" },
  {
    label: "University of Chicago Law School",
    value: "university-of-chicago-law-school",
  },
  {
    label: "Chicago-Kent College of Law at Illinois Institute of Technology",
    value: "chicago-kent-college-of-law",
  },
  {
    label: "University of Cincinnati College of Law",
    value: "university-of-cincinnati-college-of-law",
  },
  {
    label: "City University of New York (CUNY) School of Law",
    value: "cuny-school-of-law",
  },
  {
    label: "Cleveland State University College of Law",
    value: "cleveland-state-university-college-of-law",
  },
  {
    label: "University of Colorado Law School",
    value: "university-of-colorado-law-school",
  },
  { label: "Columbia Law School", value: "columbia-law-school" },
  {
    label: "University of Connecticut School of Law",
    value: "university-of-connecticut-school-of-law",
  },
  {
    label: "Western Michigan University Thomas M. Cooley Law School",
    value: "cooley-law-school",
  },
  { label: "Cornell Law School", value: "cornell-law-school" },
  {
    label: "Creighton University School of Law",
    value: "creighton-university-school-of-law",
  },
  {
    label: "University of Dayton School of Law",
    value: "university-of-dayton-school-of-law",
  },
  {
    label: "University of Denver Sturm College of Law",
    value: "university-of-denver-law-school",
  },
  {
    label: "DePaul University College of Law",
    value: "depaul-university-college-of-law",
  },
  {
    label: "University of Detroit Mercy School of Law",
    value: "university-of-detroit-mercy-school-of-law",
  },
  {
    label:
      "University of the District of Columbia David A. Clarke School of Law",
    value: "university-of-district-of-columbia-law-school",
  },
  {
    label: "Drake University Law School",
    value: "drake-university-law-school",
  },
  {
    label: "Drexel University Thomas R. Kline School of Law",
    value: "drexel-university-school-of-law",
  },
  {
    label: "Duke University School of Law",
    value: "duke-university-school-of-law",
  },
  {
    label: "Duquesne University School of Law",
    value: "duquesne-university-school-of-law",
  },
  {
    label: "Elon University School of Law",
    value: "elon-university-school-of-law",
  },
  {
    label: "Emory University School of Law",
    value: "emory-university-school-of-law",
  },
  {
    label: "Faulkner University Thomas Goode Jones School of Law",
    value: "faulkner-university-school-of-law",
  },
  {
    label: "University of Florida Levin College of Law",
    value: "university-of-florida-college-of-law",
  },
  {
    label: "Florida A&M University College of Law",
    value: "florida-a-m-university-college-of-law",
  },
  {
    label: "Florida International University College of Law",
    value: "florida-international-university-college-of-law",
  },
  {
    label: "Florida State University College of Law",
    value: "florida-state-university-college-of-law",
  },
  {
    label: "Fordham University School of Law",
    value: "fordham-university-school-of-law",
  },
  {
    label: "George Mason University Antonin Scalia Law School",
    value: "george-mason-university-law-school",
  },
  {
    label: "Georgetown University Law Center",
    value: "georgetown-university-law-center",
  },
  {
    label: "The George Washington University Law School",
    value: "george-washington-university-law-school",
  },
  {
    label: "University of Georgia School of Law",
    value: "university-of-georgia-school-of-law",
  },
  {
    label: "Georgia State University College of Law",
    value: "georgia-state-university-college-of-law",
  },
  {
    label: "Golden Gate University School of Law",
    value: "golden-gate-university-school-of-law",
  },
  {
    label: "Gonzaga University School of Law",
    value: "gonzaga-university-school-of-law",
  },
  { label: "Harvard Law School", value: "harvard-law-school" },
  {
    label: "University of Hawaii William S. Richardson School of Law",
    value: "university-of-hawaii-school-of-law",
  },
  {
    label: "Hofstra University School of Law",
    value: "hofstra-university-school-of-law",
  },
  {
    label: "South Texas College of Law Houston",
    value: "south-texas-college-of-law-houston",
  },
  {
    label: "Howard University School of Law",
    value: "howard-university-school-of-law",
  },
  {
    label: "University of Idaho College of Law",
    value: "university-of-idaho-college-of-law",
  },
  {
    label: "University of Illinois Chicago School of Law",
    value: "university-of-illinois-chicago-law-school",
  },
  {
    label: "University of Illinois College of Law",
    value: "university-of-illinois-college-of-law",
  },
  {
    label: "Indiana University Maurer School of Law",
    value: "indiana-university-maurer-school-of-law",
  },
  {
    label: "Indiana University Robert H. McKinney School of Law",
    value: "indiana-university-robert-h-mckinney-school-of-law",
  },
  {
    label: "Inter-American University of Puerto Rico School of Law",
    value: "inter-american-university-school-of-law",
  },
  {
    label: "University of Iowa College of Law",
    value: "university-of-iowa-college-of-law",
  },
  { label: "Jacksonville Law School", value: "jacksonville-law-school" },
  {
    label: "Judge Advocate General's School",
    value: "judge-advocate-generals-school",
  },
  {
    label: "University of Kansas School of Law",
    value: "university-of-kansas-school-of-law",
  },
  {
    label: "University of Kentucky College of Law",
    value: "university-of-kentucky-college-of-law",
  },
  {
    label: "Liberty University School of Law",
    value: "liberty-university-school-of-law",
  },
  {
    label: "Lincoln Memorial University Duncan School of Law",
    value: "lincoln-memorial-university-school-of-law",
  },
  { label: "Lewis & Clark Law School", value: "lewis-and-clark-law-school" },
  {
    label: "Louisiana State University Paul M. Hebert Law Center",
    value: "louisiana-state-university-law-center",
  },
  { label: "Louisville Law School", value: "louisville-law-school" },
  {
    label: "Loyola University Chicago School of Law",
    value: "loyola-university-chicago-law-school",
  },
  {
    label: "Loyola Marymount University Loyola Law School",
    value: "loyola-marymount-university-loyola-law-school",
  },
  {
    label: "Loyola University New Orleans College of Law",
    value: "loyola-university-new-orleans-college-of-law",
  },
  {
    label: "University of Maine School of Law",
    value: "university-of-maine-school-of-law",
  },
  {
    label: "Marquette University Law School",
    value: "marquette-university-law-school",
  },
  {
    label: "University of Maryland Carey School of Law",
    value: "university-of-maryland-carey-school-of-law",
  },
  {
    label: "University of Massachusetts School of Law",
    value: "university-of-massachusetts-school-of-law",
  },
  {
    label: "McGeorge School of Law, University of the Pacific",
    value: "mcgeorge-school-of-law",
  },
  {
    label: "University of Memphis Cecil C. Humphreys School of Law",
    value: "university-of-memphis-cecil-c-humphreys-school-of-law",
  },
  {
    label: "Mercer University School of Law",
    value: "mercer-university-school-of-law",
  },
  {
    label: "University of Miami School of Law",
    value: "university-of-miami-school-of-law",
  },
  {
    label: "Michigan State University College of Law",
    value: "michigan-state-university-college-of-law",
  },
  {
    label: "University of Michigan Law School",
    value: "university-of-michigan-law-school",
  },
  {
    label: "University of Minnesota Law School",
    value: "university-of-minnesota-law-school",
  },
  {
    label: "Mississippi College School of Law",
    value: "mississippi-college-school-of-law",
  },
  {
    label: "University of Mississippi School of Law",
    value: "university-of-mississippi-school-of-law",
  },
  {
    label: "University of Missouri School of Law",
    value: "university-of-missouri-school-of-law",
  },
  {
    label: "University of Missouri-Kansas City School of Law",
    value: "university-of-missouri-kansas-city-school-of-law",
  },
  {
    label: "Mitchell Hamline School of Law",
    value: "mitchell-hamline-school-of-law",
  },
  {
    label: "University of Montana School of Law",
    value: "university-of-montana-school-of-law",
  },
  {
    label: "University of Nebraska College of Law",
    value: "university-of-nebraska-college-of-law",
  },
  {
    label: "University of Nevada, Las Vegas, William S. Boyd School of Law",
    value: "university-of-nevada-las-vegas-william-s-boyd-school-of-law",
  },
  { label: "New England Law | Boston", value: "new-england-law-boston" },
  {
    label: "University of New Mexico School of Law",
    value: "university-of-new-mexico-school-of-law",
  },
  {
    label: "Franklin Pierce School of Law",
    value: "franklin-pierce-school-of-law",
  },
  { label: "New York Law School", value: "new-york-law-school" },
  {
    label: "New York University School of Law",
    value: "new-york-university-school-of-law",
  },
  {
    label: "University of North Carolina School of Law",
    value: "university-of-north-carolina-school-of-law",
  },
  {
    label: "North Carolina Central University School of Law",
    value: "north-carolina-central-university-school-of-law",
  },
  {
    label: "University of North Dakota School of Law",
    value: "university-of-north-dakota-school-of-law",
  },
  {
    label: "Northeastern University School of Law",
    value: "northeastern-university-school-of-law",
  },
  {
    label: "Northern Illinois University College of Law",
    value: "northern-illinois-university-college-of-law",
  },
  {
    label: "Northern Kentucky University Chase College of Law",
    value: "northern-kentucky-university-chase-college-of-law",
  },

  {
    label: "Northwestern University Pritzker School of Law",
    value: "northwestern-university-pritzker-school-of-law",
  },
  {
    label: "University of Notre Dame Law School",
    value: "university-of-notre-dame-law-school",
  },
  {
    label: "Nova Southeastern University Shepard Broad College of Law",
    value: "nova-southeastern-university-shepard-broad-college-of-law",
  },
  {
    label: "Ohio Northern University Pettit College of Law",
    value: "ohio-northern-university-pettit-college-of-law",
  },
  {
    label: "The Ohio State University Moritz College of Law",
    value: "the-ohio-state-university-moritz-college-of-law",
  },
  {
    label: "University of Oklahoma College of Law",
    value: "university-of-oklahoma-college-of-law",
  },
  {
    label: "Oklahoma City University School of Law",
    value: "oklahoma-city-university-school-of-law",
  },
  {
    label: "University of Oregon School of Law",
    value: "university-of-oregon-school-of-law",
  },
  {
    label: "Pace University Elisabeth Haub School of Law",
    value: "pace-university-elisabeth-haub-school-of-law",
  },
  {
    label: "University of Pennsylvania Carey Law School",
    value: "university-of-pennsylvania-carey-law-school",
  },
  { label: "Penn State Dickinson Law", value: "penn-state-dickinson-law" },
  {
    label: "Pepperdine University Caruso School of Law",
    value: "pepperdine-university-caruso-school-of-law",
  },
  {
    label: "University of Pittsburgh School of Law",
    value: "university-of-pittsburgh-school-of-law",
  },
  {
    label: "Pontifical Catholic University of Puerto Rico School of Law",
    value: "pontifical-catholic-university-of-puerto-rico-school-of-law",
  },
  {
    label: "University of Puerto Rico School of Law",
    value: "university-of-puerto-rico-school-of-law",
  },
  {
    label: "Quinnipiac University School of Law",
    value: "quinnipiac-university-school-of-law",
  },
  {
    label: "Regent University School of Law",
    value: "regent-university-school-of-law",
  },
  {
    label: "University of Richmond School of Law",
    value: "university-of-richmond-school-of-law",
  },
  {
    label: "Roger Williams University School of Law",
    value: "roger-williams-university-school-of-law",
  },
  { label: "Rutgers Law School", value: "rutgers-law-school" },
  {
    label: "St. John's University School of Law",
    value: "st-johns-university-school-of-law",
  },
  {
    label: "Saint Louis University School of Law",
    value: "saint-louis-university-school-of-law",
  },
  {
    label: "St. Mary's University School of Law",
    value: "st-marys-university-school-of-law",
  },
  {
    label: "University of St. Thomas School of Law (Florida)",
    value: "university-of-st-thomas-school-of-law-florida",
  },
  {
    label: "University of St. Thomas School of Law (Minnesota)",
    value: "university-of-st-thomas-school-of-law-minnesota",
  },
  {
    label: "Samford University Cumberland School of Law",
    value: "samford-university-cumberland-school-of-law",
  },
  {
    label: "University of San Diego School of Law",
    value: "university-of-san-diego-school-of-law",
  },
  {
    label: "University of San Francisco School of Law",
    value: "university-of-san-francisco-school-of-law",
  },
  {
    label: "Santa Clara University School of Law",
    value: "santa-clara-university-school-of-law",
  },
  {
    label: "Seattle University School of Law",
    value: "seattle-university-school-of-law",
  },
  {
    label: "Seton Hall University School of Law",
    value: "seton-hall-university-school-of-law",
  },
  {
    label: "University of South Carolina School of Law",
    value: "university-of-south-carolina-school-of-law",
  },
  {
    label: "University of South Dakota School of Law",
    value: "university-of-south-dakota-school-of-law",
  },
  {
    label: "South Texas College of Law Houston",
    value: "south-texas-college-of-law-houston",
  },
  {
    label: "Southern University Law Center",
    value: "southern-university-law-center",
  },
  {
    label: "University of Southern California Gould School of Law",
    value: "university-of-southern-california-gould-school-of-law",
  },
  {
    label: "Southern Illinois University School of Law",
    value: "southern-illinois-university-school-of-law",
  },
  {
    label: "Southern Methodist University Dedman School of Law",
    value: "southern-methodist-university-dedman-school-of-law",
  },
  { label: "Southwestern Law School", value: "southwestern-law-school" },
  { label: "Stanford Law School", value: "stanford-law-school" },
  {
    label: "Stetson University College of Law",
    value: "stetson-university-college-of-law",
  },
  {
    label: "Suffolk University Law School",
    value: "suffolk-university-law-school",
  },
  {
    label: "Syracuse University College of Law",
    value: "syracuse-university-college-of-law",
  },
  {
    label: "Temple University Beasley School of Law",
    value: "temple-university-beasley-school-of-law",
  },
  {
    label: "The University of Tennessee College of Law",
    value: "university-of-tennessee-college-of-law",
  },
  {
    label: "The University of Texas School of Law",
    value: "university-of-texas-school-of-law",
  },
  {
    label: "Texas A&M University School of Law",
    value: "texas-am-university-school-of-law",
  },
  {
    label: "Texas Southern University Thurgood Marshall School of Law",
    value: "texas-southern-university-thurgood-marshall-school-of-law",
  },
  {
    label: "Texas Tech University School of Law",
    value: "texas-tech-university-school-of-law",
  },
  {
    label: "The University of Toledo College of Law",
    value: "university-of-toledo-college-of-law",
  },
  {
    label: "Touro College Jacob D. Fuchsberg Law Center",
    value: "touro-college-jacob-d-fuchsberg-law-center",
  },
  {
    label: "Tulane University Law School",
    value: "tulane-university-law-school",
  },
  {
    label: "University of Tulsa College of Law",
    value: "university-of-tulsa-college-of-law",
  },
  {
    label: "University of North Texas Dallas College of Law",
    value: "university-of-north-texas-dallas-college-of-law",
  },
  {
    label: "University of Utah S.J. Quinney College of Law",
    value: "university-of-utah-s-j-quinney-college-of-law",
  },
  {
    label: "Vanderbilt University Law School",
    value: "vanderbilt-university-law-school",
  },
  { label: "Vermont Law School", value: "vermont-law-school" },
  {
    label: "Villanova University Charles Widger School of Law",
    value: "villanova-university-charles-widger-school-of-law",
  },
  {
    label: "University of Virginia School of Law",
    value: "university-of-virginia-school-of-law",
  },
  {
    label: "Wake Forest University School of Law",
    value: "wake-forest-university-school-of-law",
  },
  {
    label: "Washburn University School of Law",
    value: "washburn-university-school-of-law",
  },
  {
    label: "Washington and Lee University School of Law",
    value: "washington-and-lee-university-school-of-law",
  },
  {
    label: "The George Washington University Law School",
    value: "george-washington-university-law-school",
  },
  {
    label: "Washington University in St. Louis School of Law",
    value: "washington-university-in-st-louis-school-of-law",
  },
  {
    label: "Wayne State University Law School",
    value: "wayne-state-university-law-school",
  },
  {
    label: "Western New England University School of Law",
    value: "western-new-england-university-school-of-law",
  },
  {
    label: "Western State College of Law at Argosy University",
    value: "western-state-college-of-law",
  },
  {
    label: "West Virginia University College of Law",
    value: "west-virginia-university-college-of-law",
  },
  {
    label: "Widener University Delaware Law School",
    value: "widener-university-delaware-law-school",
  },
  {
    label: "Widener University Commonwealth Law School",
    value: "widener-university-commonwealth-law-school",
  },
  {
    label: "Willamette University College of Law",
    value: "willamette-university-college-of-law",
  },
  {
    label: "College of William & Mary Law School",
    value: "college-of-william-and-mary-law-school",
  },
  {
    label: "Wilmington University College of Law",
    value: "wilmington-university-college-of-law",
  },
  {
    label: "University of Wisconsin Law School",
    value: "university-of-wisconsin-law-school",
  },
  {
    label: "University of Wyoming College of Law",
    value: "university-of-wyoming-college-of-law",
  },
  { label: "Yale Law School", value: "yale-law-school" },
  {
    label: "Yeshiva University Benjamin N. Cardozo School of Law",
    value: "yeshiva-university-cardozo-school-of-law",
  },
];

const degrees = [
  { label: "Juris Doctor (JD)", value: "juris-doctor-jd" },
  { label: "Master of Laws (LL.M.)", value: "master-of-laws-llm" },
  {
    label: "Doctor of Juridical Science (SJD)",
    value: "doctor-of-juridical-science-sjd",
  },
  { label: "Bachelor of Laws (LL.B.)", value: "bachelor-of-laws-llb" },
  {
    label: "Master of Legal Studies (MLS)",
    value: "master-of-legal-studies-mls",
  },
  {
    label: "Master of Dispute Resolution (MDR)",
    value: "master-of-dispute-resolution-mdr",
  },
  { label: "Doctor of Law (JSD)", value: "doctor-of-law-jsd" },
  {
    label: "Doctor of Comparative Law (DCL)",
    value: "doctor-of-comparative-law-dcl",
  },
  {
    label: "Legal Practice Course (LPC)",
    value: "legal-practice-course-lpc",
  },
  {
    label: "Bar Professional Training Course (BPTC)",
    value: "bar-professional-training-course-bptc",
  },
  { label: "Paralegal Certificate", value: "paralegal-certificate" },
  {
    label: "Certified Legal Manager (CLM)",
    value: "certified-legal-manager-clm",
  },
  { label: "Certified Paralegal (CP)", value: "certified-paralegal-cp" },
  {
    label: "Certified Specialist in Family Law",
    value: "certified-specialist-in-family-law",
  },
  {
    label: "Certified Specialist in Immigration Law",
    value: "certified-specialist-in-immigration-law",
  },
  {
    label: "Certified Specialist in Criminal Law",
    value: "certified-specialist-in-criminal-law",
  },
  {
    label: "Certified Specialist in Tax Law",
    value: "certified-specialist-in-tax-law",
  },
  {
    label: "Certified Specialist in Personal Injury",
    value: "certified-specialist-in-personal-injury",
  },
  {
    label: "Certified Specialist in Civil Litigation",
    value: "certified-specialist-in-civil-litigation",
  },
  {
    label: "Master of Science in Law (MSL)",
    value: "master-of-science-in-law-msl",
  },
  {
    label: "Doctor of Business Law (DBL)",
    value: "doctor-of-business-law-dbl",
  },
];

const positions = [
  { label: "Partner", value: "partner" },
  { label: "Senior Partner", value: "senior-partner" },
  { label: "Managing Partner", value: "managing-partner" },
  { label: "Associate", value: "associate" },
  { label: "Senior Associate", value: "senior-associate" },
  { label: "Of Counsel", value: "of-counsel" },
  { label: "General Counsel", value: "general-counsel" },
  { label: "Chief Legal Officer", value: "chief-legal-officer" },
  { label: "Legal Director", value: "legal-director" },
  { label: "Legal Manager", value: "legal-manager" },
  { label: "Corporate Counsel", value: "corporate-counsel" },
  { label: "Trial Attorney", value: "trial-attorney" },
  { label: "Litigation Attorney", value: "litigation-attorney" },
  { label: "Real Estate Attorney", value: "real-estate-attorney" },
  { label: "In-House Counsel", value: "in-house-counsel" },
  { label: "Legal Intern", value: "legal-intern" },
];

export const professionalMemberships = [
  { label: "American Bar Association", value: "american-bar-association" },
  { label: "National Bar Association", value: "national-bar-association" },
  {
    label: "Hispanic National Bar Association",
    value: "hispanic-national-bar-association",
  },
  {
    label: "National Asian Pacific American Bar Association",
    value: "national-asian-pacific-american-bar-association",
  },
  {
    label: "National Native American Bar Association",
    value: "national-native-american-bar-association",
  },
  {
    label: "American Association for Justice",
    value: "american-association-for-justice",
  },
  {
    label: "National Association of Criminal Defense Lawyers",
    value: "national-association-of-criminal-defense-lawyers",
  },
  {
    label: "American Immigration Lawyers Association",
    value: "american-immigration-lawyers-association",
  },
  {
    label: "National Association of Women Lawyers",
    value: "national-association-of-women-lawyers",
  },
  {
    label: "National Association of Women Judges",
    value: "national-association-of-women-judges",
  },
  {
    label: "Association of Corporate Counsel",
    value: "association-of-corporate-counsel",
  },
  {
    label: "American Intellectual Property Law Association",
    value: "american-intellectual-property-law-association",
  },
  {
    label: "Association of Life Insurance Counsel",
    value: "association-of-life-insurance-counsel",
  },
  {
    label: "Maritime Law Association of the United States",
    value: "maritime-law-association-of-the-united-states",
  },
  { label: "Energy Bar Association", value: "energy-bar-association" },
  { label: "American Law Institute", value: "american-law-institute" },
  { label: "Federal Bar Association", value: "federal-bar-association" },
  {
    label: "Federal Circuit Bar Association",
    value: "federal-circuit-bar-association",
  },
  {
    label: "Federal Communications Bar Association",
    value: "federal-communications-bar-association",
  },
  {
    label: "Judge Advocates Association",
    value: "judge-advocates-association",
  },
  {
    label: "American Arbitration Association",
    value: "american-arbitration-association",
  },
  { label: "Defense Research Institute", value: "defense-research-institute" },
  {
    label: "Federation of Defense and Corporate Counsel",
    value: "federation-of-defense-and-corporate-counsel",
  },
  {
    label: "Association of American Law Schools",
    value: "association-of-american-law-schools",
  },
  {
    label: "American Academy of Matrimonial Lawyers",
    value: "american-academy-of-matrimonial-lawyers",
  },
  {
    label: "American Academy of Forensic Sciences",
    value: "american-academy-of-forensic-sciences",
  },
  {
    label: "National Association of Attorneys General",
    value: "national-association-of-attorneys-general",
  },
  {
    label: "Association of Prosecuting Attorneys",
    value: "association-of-prosecuting-attorneys",
  },
  {
    label: "National Board of Trial Advocacy",
    value: "national-board-of-trial-advocacy",
  },
  {
    label: "National Association of Muslim Lawyers",
    value: "national-association-of-muslim-lawyers",
  },
];

const practiceAreas = [
  {
    label: "Criminal Law",
    value: "criminal-law",
    children: [
      { label: "White Collar Crime", value: "white-collar-crime" },
      { label: "Drug Offenses", value: "drug-offenses" },
      { label: "DUI/DWI", value: "dui-dwi" },
      { label: "Violent Crimes", value: "violent-crimes" },
      { label: "Juvenile Delinquency", value: "juvenile-delinquency" },
      { label: "Federal Crimes", value: "federal-crimes" },
      { label: "Sex Crimes", value: "sex-crimes" },
    ],
  },
  {
    label: "Corporate Law",
    value: "corporate-law",
    children: [
      { label: "Mergers & Acquisitions", value: "mergers-acquisitions" },
      { label: "Corporate Governance", value: "corporate-governance" },
      { label: "Securities Law", value: "securities-law" },
      { label: "Commercial Contracts", value: "commercial-contracts" },
      { label: "Regulatory Compliance", value: "regulatory-compliance" },
      { label: "Corporate Litigation", value: "corporate-litigation" },
    ],
  },
  {
    label: "Family Law",
    value: "family-law",
    children: [
      { label: "Divorce", value: "divorce" },
      {
        label: "Child Custody & Visitation",
        value: "child-custody-visitation",
      },
      { label: "Child Support", value: "child-support" },
      { label: "Adoption", value: "adoption" },
      {
        label: "Prenuptial & Postnuptial Agreements",
        value: "prenuptial-postnuptial",
      },
      { label: "Domestic Violence", value: "domestic-violence" },
      {
        label: "Guardianship & Conservatorship",
        value: "guardianship-conservatorship",
      },
    ],
  },
  {
    label: "Intellectual Property Law",
    value: "intellectual-property-law",
    children: [
      { label: "Copyright Law", value: "copyright-law" },
      { label: "Trademark Law", value: "trademark-law" },
      { label: "Patent Law", value: "patent-law" },
      { label: "Trade Secrets", value: "trade-secrets" },
      { label: "Licensing Agreements", value: "licensing-agreements" },
      { label: "IP Litigation", value: "ip-litigation" },
    ],
  },
  {
    label: "Tax Law",
    value: "tax-law",
    children: [
      { label: "Corporate Tax", value: "corporate-tax" },
      { label: "Personal Income Tax", value: "personal-income-tax" },
      { label: "International Tax", value: "international-tax" },
      { label: "Estate & Gift Tax", value: "estate-gift-tax" },
      {
        label: "Tax Planning & Compliance",
        value: "tax-planning-compliance",
      },
      { label: "Tax Litigation", value: "tax-litigation" },
    ],
  },
  {
    label: "Environmental Law",
    value: "environmental-law",
    children: [
      {
        label: "Pollution Control & Air Quality",
        value: "pollution-control-air-quality",
      },
      {
        label: "Hazardous Waste Management",
        value: "hazardous-waste-management",
      },
      {
        label: "Environmental Impact Assessments",
        value: "environmental-impact-assessments",
      },
      { label: "Land Use & Zoning", value: "land-use-zoning" },
      {
        label: "Natural Resource & Energy Law",
        value: "natural-resource-energy-law",
      },
      {
        label: "Climate Change Regulation",
        value: "climate-change-regulation",
      },
    ],
  },
  {
    label: "Labor Law",
    value: "labor-law",
    children: [
      {
        label: "Employment Discrimination",
        value: "employment-discrimination",
      },
      { label: "Wage and Hour Disputes", value: "wage-hour-disputes" },
      { label: "Workers’ Compensation", value: "workers-compensation" },
      { label: "Labor Union Relations", value: "labor-union-relations" },
      {
        label: "Occupational Safety & Health",
        value: "occupational-safety-health",
      },
      { label: "Employee Benefits", value: "employee-benefits" },
    ],
  },
  {
    label: "Real Estate Law",
    value: "real-estate-law",
    children: [
      {
        label: "Residential Transactions",
        value: "residential-transactions",
      },
      { label: "Commercial Transactions", value: "commercial-transactions" },
      {
        label: "Landlord-Tenant Disputes",
        value: "landlord-tenant-disputes",
      },
      { label: "Zoning & Land Use", value: "zoning-land-use" },
      {
        label: "Property Development & Planning",
        value: "property-development-planning",
      },
      {
        label: "Title, Escrow & Foreclosure",
        value: "title-escrow-foreclosure",
      },
    ],
  },
  {
    label: "Immigration Law",
    value: "immigration-law",
    children: [
      {
        label: "Family-Based Immigration",
        value: "family-based-immigration",
      },
      {
        label: "Employment-Based Immigration",
        value: "employment-based-immigration",
      },
      {
        label: "Deportation & Removal Defense",
        value: "deportation-removal-defense",
      },
      { label: "Asylum & Refugee Law", value: "asylum-refugee-law" },
      {
        label: "Naturalization & Citizenship",
        value: "naturalization-citizenship",
      },
      {
        label: "Visa Applications & Appeals",
        value: "visa-applications-appeals",
      },
    ],
  },
  {
    label: "Bankruptcy Law",
    value: "bankruptcy-law",
    children: [
      { label: "Chapter 7 Liquidation", value: "chapter-7-liquidation" },
      {
        label: "Chapter 11 Reorganization",
        value: "chapter-11-reorganization",
      },
      {
        label: "Chapter 13 Consumer Bankruptcy",
        value: "chapter-13-consumer-bankruptcy",
      },
      { label: "Bankruptcy Litigation", value: "bankruptcy-litigation" },
      {
        label: "Corporate vs. Consumer Bankruptcy",
        value: "corporate-vs-consumer-bankruptcy",
      },
    ],
  },
  {
    label: "Entertainment Law",
    value: "entertainment-law",
    children: [
      {
        label: "Media & Production Contracts",
        value: "media-production-contracts",
      },
      { label: "Music & Film Law", value: "music-film-law" },
      { label: "Talent Representation", value: "talent-representation" },
      {
        label: "Intellectual Property in Entertainment",
        value: "ip-entertainment",
      },
      { label: "Licensing & Distribution", value: "licensing-distribution" },
      {
        label: "Digital Rights Management",
        value: "digital-rights-management",
      },
    ],
  },
  {
    label: "Personal Injury Law",
    value: "personal-injury-law",
    children: [
      { label: "Motor Vehicle Accidents", value: "motor-vehicle-accidents" },
      { label: "Slip and Fall", value: "slip-and-fall" },
      { label: "Product Liability", value: "product-liability" },
      { label: "Workplace Accidents", value: "workplace-accidents" },
      { label: "Premises Liability", value: "premises-liability" },
      {
        label: "Catastrophic & Brain Injuries",
        value: "catastrophic-brain-injuries",
      },
    ],
  },
  {
    label: "Medical Malpractice Law",
    value: "medical-malpractice-law",
    children: [
      {
        label: "Misdiagnosis & Delayed Diagnosis",
        value: "misdiagnosis-delayed-diagnosis",
      },
      { label: "Surgical Errors", value: "surgical-errors" },
      { label: "Birth Injuries", value: "birth-injuries" },
      { label: "Medication Errors", value: "medication-errors" },
      { label: "Nursing Home Negligence", value: "nursing-home-negligence" },
      { label: "Informed Consent Issues", value: "informed-consent-issues" },
    ],
  },
  {
    label: "Constitutional Law",
    value: "constitutional-law",
    children: [
      { label: "Free Speech & Expression", value: "free-speech-expression" },
      {
        label: "Due Process & Equal Protection",
        value: "due-process-equal-protection",
      },
      { label: "Religious Freedom", value: "religious-freedom" },
      { label: "Privacy Rights", value: "privacy-rights" },
      { label: "Voting Rights", value: "voting-rights" },
      { label: "Separation of Powers", value: "separation-of-powers" },
      { label: "Human Rights Law", value: "human-rights-law" },
    ],
  },
  {
    label: "Civil Rights",
    value: "civil-rights",
    children: [
      { label: "Anti-Discrimination Law", value: "anti-discrimination-law" },
      { label: "Refugee & Asylum Rights", value: "refugee-asylum-rights" },
      { label: "Indigenous Rights", value: "indigenous-rights" },
      { label: "Prisoner Rights", value: "prisoner-rights" },
      {
        label: "International Human Rights Treaties",
        value: "international-human-rights-treaties",
      },
    ],
  },
  {
    label: "Trust and Estate Law",
    value: "trust-estate-law",
    children: [
      { label: "Wills & Trusts", value: "wills-trusts" },
      {
        label: "Estate Planning & Administration",
        value: "estate-planning-administration",
      },
      { label: "Probate Litigation", value: "probate-litigation" },
      { label: "Inheritance Disputes", value: "inheritance-disputes" },
      { label: "Asset Protection", value: "asset-protection" },
      { label: "Charitable Trusts", value: "charitable-trusts" },
    ],
  },
  {
    label: "International Law",
    value: "international-law",
    children: [
      { label: "International Trade Law", value: "international-trade-law" },
      {
        label: "Diplomatic & Consular Law",
        value: "diplomatic-consular-law",
      },
      {
        label: "International Arbitration",
        value: "international-arbitration",
      },
      { label: "Humanitarian Law", value: "humanitarian-law" },
      {
        label: "International Criminal Law",
        value: "international-criminal-law",
      },
      { label: "Treaty & Convention Law", value: "treaty-convention-law" },
    ],
  },
  {
    label: "Antitrust Law",
    value: "antitrust-law",
    children: [
      {
        label: "Merger Review & Regulation",
        value: "merger-review-regulation",
      },
      { label: "Price Fixing & Collusion", value: "price-fixing-collusion" },
      { label: "Monopolistic Practices", value: "monopolistic-practices" },
      { label: "Cartel Activities", value: "cartel-activities" },
      {
        label: "Market Allocation Schemes",
        value: "market-allocation-schemes",
      },
      { label: "Abuse of Dominance", value: "abuse-dominance" },
    ],
  },
  {
    label: "Admiralty Law",
    value: "admiralty-law",
    children: [
      { label: "Maritime Commerce", value: "maritime-commerce" },
      {
        label: "Shipping & Cargo Disputes",
        value: "shipping-cargo-disputes",
      },
      { label: "Marine Insurance", value: "marine-insurance" },
      { label: "Salvage & Towage Rights", value: "salvage-towage-rights" },
      { label: "Cargo Claims", value: "cargo-claims" },
      {
        label: "Piracy & Maritime Security",
        value: "piracy-maritime-security",
      },
    ],
  },
  {
    label: "Health Law",
    value: "health-law",
    children: [
      {
        label: "Healthcare Regulation & Compliance",
        value: "healthcare-regulation-compliance",
      },
      {
        label: "Hospital & Patient Rights",
        value: "hospital-patient-rights",
      },
      { label: "Health Insurance Law", value: "health-insurance-law" },
      { label: "Public Health Law", value: "public-health-law" },
      {
        label: "Bioethics & Medical Research Law",
        value: "bioethics-medical-research-law",
      },
      { label: "FDA & Drug Regulation", value: "fda-drug-regulation" },
    ],
  },
];

const suffixes = [
  { label: "Esq.", value: "esq" },
  { label: "Attorney at Law", value: "attorney-at-law" },
  { label: "J.D.", value: "jd" },
  { label: "LL.M.", value: "llm" },
  { label: "S.J.D.", value: "sjd" },
];

export { schools, degrees, positions, suffixes, practiceAreas };
